import { render, staticRenderFns } from "./InitialBudgetCreator.vue?vue&type=template&id=2b398822&scoped=true&"
import script from "./InitialBudgetCreator.vue?vue&type=script&lang=js&"
export * from "./InitialBudgetCreator.vue?vue&type=script&lang=js&"
import style0 from "./InitialBudgetCreator.vue?vue&type=style&index=0&id=2b398822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b398822",
  null
  
)

export default component.exports